<template>
  <div>
    <div class="row checkup-product-row">
      <div class="col col-6">
        <label for="selectedSkinCheckUpProduct" class="pb-1"
          >Skin checkup products</label
        >
        <multiselect
          id="selectedSkinCheckUpProduct"
          v-model="productSelected"
          :options="productOptions"
          label="fullText"
          track-by="id"
          :class="{
            'input--select--error': isSubmit && error.errorProductParentCodes,
          }"
        />
        <div
          v-if="isSubmit && error.errorProductParentCodes"
          class="text-error"
        >
          {{ error.errorProductParentCodes.message }}
        </div>
      </div>
      <div class="col col-2">
        <button
          class="btn btn-outline-success w-50 btn-add-product mt-8"
          @click="addSkinCheckupProduct"
          :disabled="!productSelected"
        >
          Add
        </button>
      </div>
    </div>
    <v-dialog v-model="showDialog" width="500" persistent>
      <div class="content-dialog">
        <h3>{{ message }}</h3>
        <div class="row text-center">
          <div class="col">
            <button class="btn-back" @click="showDialog = false">ปิด</button>
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import ProductService from "services/api/product.service";

export default {
  name: "AddSkinCheckupProduct",
  props: {
    error: {
      type: Object,
      default: () => {},
    },
    isSubmit: {
      type: Boolean,
      default: () => false,
    },
    listSkinCheckupProducts: {
      type: Array,
      default: () => [],
    },
    brandCode: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      productSelected: null,
      productOptions: [],
      showDialog: false,
      message: null,
    };
  },
  mounted() {
    this.getProducts();
  },
  methods: {
    addSkinCheckupProduct() {
      const isDuplicateProduct = this.listSkinCheckupProducts.some(
        (product) => product.productCode === this.productSelected.code
      );
      if (isDuplicateProduct) {
        this.showDialog = true;
        this.message = "มีผลิตภัณ์นี้ในรายการแล้ว";
      } else {
        this.listSkinCheckupProducts.push({
          productCode: this.productSelected.code,
          isDelete: true,
        });
        this.resetSkinCheckupProduct();
      }
    },
    resetSkinCheckupProduct() {
      this.productSelected = null;
    },
    async getProducts() {
      const brandCode = this.brandCode;
      const params = {
        brand: brandCode,
      };
      await ProductService.getListProducts(params)
        .then((res) => {
          const data = res.data;
          this.productOptions = data.product.map((s) => {
            return {
              id: s.productCode,
              text: s.productName,
              fullText: `(${s.productCode}) ${s.productName}`,
              code: s.productCode,
            };
          });
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  margin: 3rem 0;
}

.text-error {
  color: red;
  font-size: 12px;
}

.btn-add-product:disabled {
  color: #222;
  border-color: transparent;
  background-color: #ddd;
}

.checkup-product-row {
  margin-bottom: -40px;
}

.input--select--error {
  border: 1px solid red;
  border-radius: 5px;
}

.content-dialog {
  height: 300px;
  background: #fff;
  overflow-x: hidden;

  h3 {
    text-align: center;
    padding: 5rem 0 2rem;
  }

  .btn-back {
    border: 1px solid #1976d2;
    width: 28%;
    height: 39px;
    border-radius: 25px;
    color: #1976d2;
  }

  .btn-back:hover {
    text-decoration: underline;
  }
}
</style>
